import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { PAGE_SIZE } from "utils/constants";
import { Table } from "./index";

// Table's own paging is built for infinite scroll: a page-number button only
// acts once the scroll container is at the bottom and then grows the page size,
// so for rows already in memory "2" or "3" does nothing. This slices the rows
// here and hands Table the caller-owned page it already supports.
export const ClientPagedTable = ({
  data = [],
  pageSize = PAGE_SIZE,
  ...props
}) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));

  // Fewer rows than before (a different strategy) must not strand the table on
  // a page that no longer exists.
  useEffect(() => {
    setPage((current) => Math.min(current, totalPages));
  }, [totalPages]);

  const pageRows = useMemo(
    () => data.slice((page - 1) * pageSize, page * pageSize),
    [data, page, pageSize]
  );

  return (
    <Table
      {...props}
      data={pageRows}
      customPagination
      initialPageSize={pageSize}
      totalRecords={data.length}
      totalPages={totalPages}
      controlledPage={page}
      handlePageChange={setPage}
    />
  );
};

ClientPagedTable.propTypes = {
  data: PropTypes.array,
  pageSize: PropTypes.number,
};
